export const redirectPlanRegex =
  /(resources|backup-care|case|discussion|profile|receipt|share|coaching|channels|toolkit|find-care)(\/.*)?(\?.*)?$/;
